import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import { useQueryMutation } from '@lore/query-connect';
import FormErrors from '../../forms/_common/FormErrors';
import validators from '../../utils/validators';
import Confirmation from './Confirmation';
import Form from './Form';
import RequestError from '../../forms/_common/RequestError';
import ErrorMessage from '../../forms/_common/ErrorMessage';
import SuccessMessage from '../../forms/_common/SuccessMessage';
import Overlay from '../../forms/_common/Overlay';

Dialog.propTypes = {
  network: PropTypes.object.isRequired
};

export default function Dialog(props) {
  const { network, router } = props;

  const [data, setData] = useState({
    networkId: network.id
  });
  const [showErrors, setShowErrors] = useState(false);

  const mutation = useQueryMutation('networkSite.create');
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      // props.onClose();
      props.onSubmit && props.onSubmit(request);
    }
  }, [success]);

  function onSubmit(site) {
    mutation.mutate({
      ...data,
      siteId: site.id
    });
  }

  function onChange(name, value) {
    const nextData = _.merge({}, data);
    nextData[name] = value;
    setData(nextData);
  }

  return (
    <DialogTemplate className="w-screen max-w-screen-sm">
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          // field: [validators.isRequired]
        }}>
          {({errors, hasError}) => {
            if (success) {
              return (
                <Confirmation
                  data={data}
                  onClose={() => {
                    props.onClose();
                    // setTimeout(function() {
                    //   props.onSubmit && props.onSubmit(request)
                    // }, 300);
                  }}
                />
              );
            }

            return (
              <Form
                data={data}
                errors={errors}
                showErrors={showErrors}
                onChange={onChange}
                onSubmit={(site) => hasError ? setShowErrors(true) : onSubmit(site)}
                onClose={props.onClose}
                alert={error ? (
                  <RequestError request={request}/>
                ) : showErrors ? (
                  <ErrorMessage>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : (false && success) ? (
                  <SuccessMessage>
                    Note updated.
                  </SuccessMessage>
                ) : null}
                network={network}
                router={router}
              />
            );
          }}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
